// extracted by mini-css-extract-plugin
module.exports = {"data":"InfoRow_data__1KDp6","label":"InfoRow_label__1_gVG","value":"InfoRow_value__2TSpH"};